import {
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Button} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$cc(Button, {
        'ev-click': this.showNotification.bind(this),
        'children': '基础用法'
    });
};